import plangridTrackEvents from "./amplitudeInit-vanilla";
import * as functions from "./functions-vanilla";
import { tns as tinyslider } from "tiny-slider/src/tiny-slider";
import * as wistia from "./wistia";

const HOME_VIDEO_HANDLE = "wistia-handle";

export const init = () => {
  plangridTrackEvents("homepage", {trackScrolling: true});

  const slider = tinyslider({
    container: document.querySelector("#review-slider"),
    items: 1,
    slideBy: "page",
    autoplay: true,
    navContainer: document.querySelector("#nav-container")
  });

  document.querySelector(".js_next").addEventListener("click", (e) => {
    slider.goTo("next");
  });

  document.querySelector(".js_prev").addEventListener("click", (e) => {
    slider.goTo("prev");
  });

  functions.embbedSvgImages();
};

document.addEventListener("DOMContentLoaded", init);

const loadHomepageVideo = () => {
  const videoContainer = document.querySelector(".video-container");
  wistia.load();
  wistia.embedVideo(HOME_VIDEO_HANDLE, video => {
    const videoCover = document.querySelector(".video-cover");

    videoCover.style.cursor = "pointer";
    videoCover.addEventListener("click", (e) => {
      e.preventDefault();
      e.target.style.display = "none";
      videoContainer.style.display = "inline-block";
      video.play();
    });
  });
};

window.addEventListener("load", loadHomepageVideo);



// WEBPACK FOOTER //
// ./src/assets/js/home.js